import api from "api";
import BlockHeader from "component/BlockHeader/BlockHeader";
import PaginationWrapper from "component/Pagination";
import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { createBrowserHistory, parsePath } from "history";
import { useLocation, useNavigate, useSearchParams, createSearchParams } from "react-router-dom";
import stateMap from "store/stateMap";
import update from 'immutability-helper';
import _ from "lodash";
import Header from "component/Header/Header";
import Footer from "component/Footer/Footer";
import Breadcrumb from "component/Breadcrumb";
import "./index.scss";
import { OfficialAccountList } from "component/OfficialAccount";

export default connect(stateMap)((props) => {

    
    let location                                = useLocation();
    let history                                 = createBrowserHistory();
    
    const [talents, setTalents]         = useState(false);
    const [countTalent, setCountTalent] = useState(false);
    const [dataLoading, setDataLoading]         = useState(false) ;
    const queryString                           = new URLSearchParams(parsePath(window.location.href).search || '');
    const [parameter, setParameter]             = useState({
        paged           : parseInt(queryString.get('page') || 1)  
        ,posts_per_page : parseInt(queryString.get('posts_per_page')) || 20
    });


    const changeParams = (e) => {
        e.preventDefault();

        if(dataLoading)
        {
            return;
        }

        let [toUpdateFilter, updatedValue] = e.currentTarget.name.split(':');

        setParameter(
            update(parameter, { $apply : function(params){

                if(params[toUpdateFilter] == updatedValue)
                {
                    params[toUpdateFilter] = '';
                }
                else
                {
                    params[toUpdateFilter] = updatedValue;
                }
    
                params.paged = 1;
    
                return _.assign({}, params);
    
            }})
        );
    }

    const loadTalent = () => {

        if(!props.auth.user)
        {
            return;
        }

        if(dataLoading)
        {
            return;
        }

        var DataToLoad = [
            api('/OfficialAccount', 'post', _.assign({}, parameter), 'Bearer ' + props.auth.token)
        ];

        if(parameter.paged === 1)
        {
            DataToLoad.push(
                api('/OfficialAccount', 'post', _.assign({get_total : 1}, parameter), 'Bearer ' + props.auth.token)
            );
        }

        setDataLoading(true);

        Promise.all(DataToLoad)
            .then((response) => {
                setDataLoading(false);

                setTalents(response[0].account);

                history.replace(
                    { search: `?${createSearchParams(parameter)}`}
                );

                if(parameter.paged === 1)
                {
                    setCountTalent( parseInt(response[1].account) );
                }

            })
            .catch((error) => {
                setDataLoading(false);
                
            })
    }
    
    useEffect(loadTalent, [props.auth.user, parameter]);

    return(
        <>
            <Header/>
            <div className="container relative official-archives">
                <Breadcrumb
                    items={[
                        ['/', 'Crowdbees']
                        ,['Official Account']
                    ]}
                />
                <div className="talents-list">
                    {
                        talents === false ? <span className="skeleton"></span>:
                        (
                            <Fragment>
                                {
                                    dataLoading ? <div><span className="skeleton"></span></div> :
                                    <>
                                        { 
                                            <BlockHeader title="Official Account" desc={"About "+ countTalent +" talents"}/>
                                        }

                                        <OfficialAccountList accounts={talents}/>

                                        <PaginationWrapper
                                            className="mt-4"
                                            activePage={parameter.paged}
                                            itemsCountPerPage={parameter.posts_per_page}
                                            totalItemsCount={countTalent}
                                            pageRangeDisplayed={5}
                                            onChange={(pagenumber) => {
                                                setParameter(update(parameter, { paged : {$set : pagenumber } }))
                                            }}
                                        />
                                    </>
                                }
                            </Fragment>
                        )
                    }
                </div>
            </div>
            <Footer/>
        </>
    )
});